import { Modal } from '@/components/shared/Modals/Modal';

type SavedFiltersModalHeaderProps = {
  title: string;
  subtitle: string;
  onClose: () => void;
};

export const SavedFiltersModalHeader = ({
  title,
  subtitle,
  onClose,
}: SavedFiltersModalHeaderProps) => {
  return (
    <Modal.Header
      headerVariant='h3'
      title={title}
      subtitle={subtitle}
      handleCancel={onClose}
    />
  );
};
